<template>
    <v-card v-if="!loading">
        <v-card-text class="pa-2">
            <v-col cols="3" class="pa-0">
                <v-text-field v-model="search" label="Search in change requests" single-line hide-details dense prepend-icon="mdi-magnify"></v-text-field>
            </v-col>
        </v-card-text>
        <v-data-table 
            :items="items" 
            :items-per-page="200" 
            :footer-props="{'items-per-page-options': [10, 50, 100, 200, -1]}"
            :search="search"
            :custom-filter="customSearch"
            :headers="headers">
            <!-- :search="search">  -->
            <template v-slot:item="props">
                <tr>
                    <td><v-simple-checkbox v-model="props.item.wzvz_selected" hideDetails :id="props.item.wzvz_encrid" :value="props.item.wzvz_encrid" class="checkSmall pb-2" @input="changeSelection()" v-if="props.item.wzvz_change_allowed&&props.item.wzvz_type==='Automatic'"/></td>
                    <td>{{ props.item.wzvz_gebr_afh_type }}</td>
                    <td>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <span v-on="on">{{ props.item.wzvz_gebr_code_aanm }}</span>
                            </template>
                            <span>{{ props.item.wzvz_gebr_naam_aanm }}</span>
                        </v-tooltip>
                    </td>
                    <td>{{ props.item.wzvz_tabel }}: <span class="spanClick" @click="openTab(props.item.url)">{{ props.item.wzvz_key1_waarde }}</span></td>
                    <td>{{ props.item.wzvz_veldnaam }}</td>
                    <td><longTextView :long_text="props.item.wzvz_veldwaarde_oud"   :max_width="250" v-if="props.item.wzvz_veldwaarde_oud"/></td>
                    <td><longTextView :long_text="props.item.wzvz_veldwaarde_nieuw" :max_width="250" v-if="props.item.wzvz_veldwaarde_nieuw"/></td>
                    <td><longTextView :long_text="props.item.wzvz_opm"              :max_width="150" v-if="props.item.wzvz_opm"/></td>
                    <td>
                        <btn_component type="avatar_icon" color="green" tooltip="Approve" icon="mdi-check-circle-outline" size="small" :data="props.item.wzvz_encrid" @actionClick="approveWzvz" v-if="props.item.wzvz_change_allowed&&props.item.wzvz_type==='Automatic'"/>
                        <btn_component type="avatar_icon" color="red" tooltip="Decline" icon="mdi-close-circle-outline" size="small" :data="props.item.wzvz_encrid" @actionClick="declineWzvz" v-if="props.item.wzvz_change_allowed&&props.item.wzvz_type==='Automatic'"/>
                        <btn_component type="text" text="Remark"  color="primary" tooltip="Approve/Decline with a remark" size="x-small" :data="props.item.wzvz_encrid" @actionClick="remarkWzvz" v-if="props.item.wzvz_change_allowed&&props.item.wzvz_type==='Automatic'"/>
                        <btn_component type="text" text="Details" color="primary" tooltip="View details & Approve/Decline" size="x-small" data="" @actionClick="detailsWzvz(props.item.wzvz_tabel, props.item.wzvz_key1_waarde)" v-if="props.item.wzvz_type==='Automatic'"/>
                        <btn_component type="text" text="Do change" color="primary" tooltip="View and execute the manual change" size="x-small" data="" @actionClick="manualWzvz(props.item)" v-if="props.item.wzvz_change_allowed&&props.item.wzvz_type==='Manual'"/>
                    </td>
                </tr>
            </template>
        </v-data-table>
        <wzvz_remark ref="wzvz_remark" @approveDeclineWzvzSelectedRemark="approveDeclineWzvzSelectedRemark" @saveSelectedRemark="saveSelectedRemark"/>
        <wzvz_details ref="wzvz_details" @approveDeclineWzvz="approveDeclineWzvz" @saveRemarkWzvz="saveRemarkWzvz"/>
        <wzvz_manual ref="wzvz_manual" @approveDeclineWzvz="approveDeclineWzvz"/>
    </v-card>
</template>

<script>
    import btn_component from "@/components/ui/buttons/btn_component.vue";
    import longTextView from "@/components/ui/fields/longTextView.vue";
    import wzvz_remark from "@/components/wzvz/wzvz_remark.vue";
    import wzvz_details from "@/components/wzvz/wzvz_details.vue";
    import wzvz_manual from "@/components/wzvz/wzvz_manual.vue";

    export default {
        components: {
            btn_component,
            longTextView,
            wzvz_remark,
            wzvz_details,
            wzvz_manual,
        },
        props: {
            view: {
                type: Array,
                required: true,
            },
            acco: {
                type: String,
                required: false,
                default: ""
            }
        },    
        data() {
            return { 
                localView: "",
                loading: true,
                selected: [],
                search: "",
                headers: [
                    { text: "", width: "3%" },
                    { text: "Department", value: "wzvz_gebr_afh_type", width: "7%" },
                    { text: "Requestor", value: "wzvz_gebr_code_aanm", width: "7%" },
                    { text: "Change", value: "wzvz_tabel", width: "10%" },
                    { text: "Field", value: "wzvz_veldnaam", width: "15%" },
                    { text: "Current Value", value: "wzvz_veldwaarde_oud", width: "15%"  },
                    { text: "Pending Value", value: "wzvz_veldwaarde_nieuw", width: "15%"  },
                    { text: "Remark", value: "wzvz_opm", width: "10%"  },
                    { text: "Actions" },
                ],
                items: [],
            }
        },  
        mounted() {
            this.search = this.acco;
            this.listWzvz(this.view);
        },
        methods: {
            listWzvz(view) {
                this.loading = true;
                this.localView = view;
                this.$axios.post("ares/json/ares/wzvz/listWzvz.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "listWzvz"
                    },
                    listWzvz: {
                        list: view,
                    }
                }).then(res => {
                    if (res.data.error) {
                        // console.log(res.data.error);
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error",
                        });
                    } else {
                        this.items = res.data.listWzvz;
                        this.selected = [];
                        this.changeSelection();
                        this.loading = false;
                    }
                });
            },
            setSearch(newSearch) {
                this.search = newSearch;
            },
            saveSelectedRemark(remark, remark_org) {
                this.saveRemarkWzvz(this.selected, remark, remark_org);
            },
            approveDeclineWzvzSelectedRemark(approve, remark) {
                this.approveDeclineWzvz(this.selected, approve, remark);
            },
            approveDeclineWzvzSelected(approve) {
                this.approveDeclineWzvz(this.selected, approve, "");
            },
            approveDeclineRemark() {
                if (this.selected.length === 0) {
                    this.$store.dispatch("setSnackbar", {
                        showing: true,
                        text: "Operation aborted: no changes selected",
                        color:"warning",
                    });
                    return
                }
                let remark = "";
                let iCount = 0;
                for (let iIndex=0;iIndex<this.items.length;iIndex++) {
                    if (this.items[iIndex].wzvz_selected) {
                        iCount++;
                        if (iCount === 1) {
                            remark = this.items[iIndex].wzvz_opm;
                        } else {
                            if (this.items[iIndex].wzvz_opm !== remark) {
                                remark = "";
                            }
                        }
                    }
                }
                this.$refs.wzvz_remark.openDialog(this.selected, remark);
            },
            approveDeclineWzvz(encrids, approve, remark) {
                if (encrids.length === 0) {
                    this.$store.dispatch("setSnackbar", {
                        showing: true,
                        text: "Operation aborted: no changes selected",
                        color:"warning",
                    });
                    return
                }
                this.$axios.post("ares/json/ares/wzvz/approveDeclineWzvz.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "approveDeclineWzvz"
                    },
                    approveDeclineWzvz: {
                        wzvz_encrids: encrids,
                        wzvz_approve: approve,
                        wzvz_remark: remark,
                    }
                }).then(res => {
                    if (res.data.error) {
                        // console.log(res.data.error);
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error",
                        });
                    } else {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.approveDeclineWzvz.text,
                            color: res.data.approveDeclineWzvz.color,
                        });
                        this.listWzvz(this.localView);
                    }
                });
            },
            saveRemarkWzvz(encrids, remark, remark_org) {
                if (encrids.length === 0) {
                    this.$store.dispatch("setSnackbar", {
                        showing: true,
                        text: "Operation aborted: no changes selected",
                        color:"warning",
                    });
                    return
                }
                this.$axios.post("ares/json/ares/wzvz/saveRemarkWzvz.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "saveRemarkWzvz"
                    },
                    saveRemarkWzvz: {
                        wzvz_encrids: encrids,
                        wzvz_remark: remark,
                        wzvz_remark_org: remark_org,
                    }
                }).then(res => {
                    if (res.data.error) {
                        // console.log(res.data.error);
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error",
                        });
                    } else {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.saveRemarkWzvz.text,
                            color: res.data.saveRemarkWzvz.color,
                        });
                        this.listWzvz(this.localView);
                    }
                });
            },
            approveWzvz(encrid) {
                this.approveDeclineWzvz([encrid], true, "");
            },
            declineWzvz(encrid) {
                this.approveDeclineWzvz([encrid], false, "");
            },
            remarkWzvz(encrid) {
                this.selected = [encrid];
                for (let iIndex=0;iIndex<this.items.length;iIndex++) {
                    this.items[iIndex].wzvz_selected = (this.items[iIndex].wzvz_encrid === encrid);
                }
                this.$emit("updateSelection", this.selected);
                this.approveDeclineRemark();
            },
            detailsWzvz(entity, entity_key) {
                this.selectAll(false);
                this.$refs.wzvz_details.openDialog(entity, entity_key);

            },
            manualWzvz(item) {
                this.$refs.wzvz_manual.openDialog(item);

            },
            selectAll(newValue) {
                this.selected = [];
                for (let i=0; i<this.items.length; i++) {
                    if (this.items[i].wzvz_change_allowed&&this.items[i].wzvz_type==="Automatic") {
                        this.items[i].wzvz_selected = newValue;
                        if (newValue) {
                            this.selected.push(this.items[i].wzvz_encrid);
                        }
                    }
                }
                this.changeSelection();
            },
            changeSelection() {
                this.selected = [];
                for (let i=0; i<this.items.length; i++) {
                    if (this.items[i].wzvz_selected) {
                        this.selected.push(this.items[i].wzvz_encrid);
                    }
                }
                this.$emit("updateSelection", this.selected); 
            },
            openTab(url) {
                if (url !== "") {
                    this.$router.open(url);
                }
            },
            customSearch (value, search, item) {
                return Object.values(item.search).some(v=>v&&v.toString().toLowerCase().includes(search.toLowerCase()))
            },
        }
    }
</script>

<style scoped> 
    .checkSmall {
        transform: scale(0.75);
        margin: 2px;
    }
    .spanClick {
        cursor: pointer;
        text-decoration: underline;
        color: blue;
    }
</style>